import { useContext, useState } from "react";
import { useFormik } from "formik";
import FormLabel from "../../../UI/Form/FormLabel";
import ButtonLoading from "../../../UI/Button/ButtonLoading";
import Alert from "../../../UI/Alert/Alert";
import { NotifyContext } from "../../../context/notifyContext";
import UserAPI from "../../../services/api/UserService";
import { Tutor } from "../../../Types/Users";

interface AcceptTutorProps {
  onClose?: () => void;
  tutor?: Tutor | null;
}

export default function AcceptTutor(props: AcceptTutorProps) {
  const { tutor } = props;

  const notify = useContext(NotifyContext);

  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: "",
    },
    onSubmit: () => {
      setLoading(true);
      if (tutor)
        UserAPI.confirm_user(tutor.user_id)
          .then((data) => {
            notify("Vous avez confirmé le tuteur");
            setError("");
            if (props.onClose) {
              props.onClose();
            }
          })
          .catch((error) => {
            setError(error);
            notify(error, "error");
          })
          .finally(() => {
            setLoading(false);
          });
    },
  });

  return (
    <div>
      <form className="px-4 py-3" onSubmit={formik.handleSubmit}>
        {error && <Alert color="error">{error}</Alert>}

        <div className={`mt-6 `}>
          <FormLabel htmlFor="title">
            Voulez-vous confirmer{" "}
            <strong>
              {tutor?.first_name} {tutor?.last_name}
            </strong>{" "}
            comme tuteur ?
          </FormLabel>
        </div>

        <ButtonLoading
          type="submit"
          loading={loading}
          label="Je confirme !"
          className="mt-4"
        />
      </form>
    </div>
  );
}
